import { ref } from 'vue'
import { apiPost } from '@/composables/useApi'
import { auth } from '@/firebase'

// 全站一个反馈弹窗；入口打开时可带上所在位置的信息（比如播放器的素材和当前句）
const isFeedbackOpen = ref(false)
const feedbackContext = ref({})

export function openFeedback(context = {}) {
  feedbackContext.value = context
  isFeedbackOpen.value = true
}

export function closeFeedback() {
  isFeedbackOpen.value = false
}

export function useFeedback() {
  return { isFeedbackOpen, feedbackContext }
}

// 未登录也能提交；登录了就带上凭证，反馈记到账号上
export function submitFeedback({ message, contactEmail, context, screenshots }) {
  const form = new FormData()
  form.append('message', message)
  form.append('contactEmail', contactEmail)
  form.append('context', JSON.stringify(context))
  screenshots.forEach((file) => form.append('screenshots', file, file.name))
  return apiPost('/api/feedback', form, { auth: Boolean(auth.currentUser) })
}
